export const setSelectedLeagueID = (id) => ({
    type: 'SET_SELECTED_LEAGUE_ID',
    id
});

export const setSelectedLeague = (league) => ({
    type: 'SET_SELECTED_LEAGUE',
    league
});